import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, of } from "rxjs";
import { take } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { WebApiService } from "../../_libs/web-api/web-api.service";
import {
	SimStatusRequest,
	SimStatusResponse,
} from "../_core/_models/mobile/mobile.models";

import { PlanSharedService } from "../plan/_services/plan-shared.service";
import {
	CartState,
	MobileActivate,
	PlanState,
	setProductOfferingMobilePlan,
	setQuoteMobilePlan,
	setSimActivate,
} from "app/_store";
import { AppState } from "app/_store/app.state";
import { PRODUCT_NAME, PRODUCT_OFFER } from "app/shared";

@Injectable({
	providedIn: "root",
})
export class MobileService {

	constructor(
		private store: Store<MobileActivate>,
		private cartStore: Store<CartState>,
		private webAPIService: WebApiService,
		private router: Router,
		private planSharedService: PlanSharedService,
		private planStore: Store<PlanState>,
		private allState: Store<AppState>
	) {}


	validateSim(simNumber: string): Observable<any> {
		const url = `leadMgmt/lead?sim=${simNumber}&brand=Dodo`;
		return this.webAPIService.get<any>(url, true, undefined, true);
	}


	getSimStatus(simNumber: string): Observable<SimStatusResponse> {
		const payload: SimStatusRequest = {
			type: "getStatus",
			validFor: {
				startDateTime: new Date(),
			},
			product : {
				productCharacteristics: [
					{
						name: "serialNumber",
						value: simNumber,
					},
				],
			},
		};
		const url = `prepayBalanceMgmt/bucket/action`;
		return this.webAPIService.postMS<any>(url, payload);
	}

	navigateToPlan(): void {
		this.router.navigate(["/plan/mobile"]);
	}

	processActivate(activate: any, simStatus: SimStatusResponse, simNumber = "", promoStacking:string = ""): void {
		const mappedActivate = this.mapActivate(activate, simStatus, simNumber, promoStacking);
		this.store.dispatch(setSimActivate({ activate: mappedActivate }));
		this.getMobilePlans(simStatus, true, promoStacking);
	}


	private mapActivate(activate: any, simStatus: SimStatusResponse, simNumber = "", promoStacking=""): any {
			let mappedActivate = {};
		if (activate?.relatedParty?.[0]) {
			mappedActivate = { ...activate?.relatedParty?.[0] };
		}
		const pContact: any[] = activate?.prospectContact;
		if (pContact?.length) {
			let prospect = {};
			for (const p of pContact) {
				prospect = { ...prospect, [p.mediumType]: p.characterstic };
			}
			mappedActivate = { ...mappedActivate, ...prospect };
		}
		return { ...activate, customerDetails: mappedActivate, simNumber, simStatus, promoStacking };
	}

	public getMobilePlans(simStatus?: SimStatusResponse, navigateToPlanPage?: boolean, promoStacking?:string): void {
		this.planSharedService
			.getProductOffering(PRODUCT_OFFER.mobile)
			.pipe(take(1))
			.subscribe((productOffering) => {
				console.log(
					"🚀 ~ mobile.service.ts ~ productOffering",
					productOffering
				);
				this.createQuote(productOffering?.[0]?.productOffering?.[0].id, simStatus, navigateToPlanPage, promoStacking);
				this.planStore.dispatch(
					setProductOfferingMobilePlan({ productOffering })
				);
			});
	}

	private createQuote(productOfferingId, simStatus: SimStatusResponse, navigateToPlanPage?: boolean, promoStacking?:string): void {
		this.planSharedService
			.createQuote(PRODUCT_NAME.mobile, productOfferingId, simStatus, promoStacking)
			.pipe(take(1))
			.subscribe((quote) => {
				console.log("🚀 ~ mobile.service.ts ~ quote", quote);
				this.planStore.dispatch(setQuoteMobilePlan({ quote }));
				
				if (navigateToPlanPage) {
					this.navigateToPlan();
				} 
			});
	}
}
